import clsx from 'clsx'
import { FaceAww, FaceExcited, FaceHappy } from './faces'
import { CSSProperties } from 'react'

type ExtendedCSSProperties = CSSProperties & {
  [key: `--${string}`]: string | number | undefined
}

type BlobbyProps = {
  color: 'dawn' | 'vibes' | 'breeze'
  expression: 'happy' | 'excited'
  facePositionX?: 'start' | 'end' | 'center'
  facePositionY?: 'start' | 'end' | 'center'
  style?: ExtendedCSSProperties
}

export const Blobby = ({
  color,
  expression,
  facePositionX = 'start',
  facePositionY = 'center',
  style,
}: BlobbyProps) => {
  const styleVars = {
    '--face-position-x': facePositionX,
    '--face-position-y': facePositionY,
    ...style,
  }

  return (
    <div
      className={clsx(
        'blob',
        `blob-color-${color}`,
        `blob-expression-${expression}`,
        `blob-face-position-x-${facePositionX}`,
        `blob-face-position-x-${facePositionY}`,
      )}
      style={styleVars}
    >
      <div className="blob-bg"></div>
      <div className="blob-faces">
        <FaceExcited />
        <FaceHappy />
      </div>
    </div>
  )
}

export const BlobbyAww = () => {
  return (
    <div className={clsx('blob', `blob-color-dawn`, `blob-awww`)}>
      <div className="blob-bg"></div>
      <div className="blob-faces">
        <FaceAww />
      </div>

      <div className="blob-hands">
        <svg
          width="34"
          height="35"
          viewBox="0 0 34 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="left-hand"
        >
          <path
            d="M20.366 32.7149L30.515 18.2425C33.279 14.3009 32.8576 8.95236 29.5103 5.49233V5.49233C26.163 2.03229 20.8313 1.43398 16.8004 4.06603L1.99989 13.7302"
            stroke="url(#paint0_linear_4415_17771)"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_4415_17771"
              x1="25.5473"
              y1="11.961"
              x2="10.9555"
              y2="24.8726"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#672554" />
              <stop offset="1" stopColor="#480B38" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="right-hand"
        >
          <path
            d="M7.20611 31.5138L2.58325 14.4527C1.3242 9.80611 3.53928 4.91961 7.86368 2.804V2.804C12.1881 0.688388 17.4055 1.93873 20.3012 5.78464L30.9335 19.9057"
            stroke="url(#paint0_linear_4415_17772)"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_4415_17772"
              x1="9.39084"
              y1="10.2347"
              x2="18.7226"
              y2="27.3388"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#672554" />
              <stop offset="1" stopColor="#480B38" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  )
}
